import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalyticsBarsAscend = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "analytics-bars-ascend" }), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3 19.5h18a1.25 1.25 0 1 1 0 2.5H3a1.25 1.25 0 1 1 0-2.5Zm1-5.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V18H4v-4.25Zm5.5-3.5c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V18h-5v-7.75Zm5.5-5c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V18h-5V5.25Zm2.62-3.23h3.13c.69 0 1.25.56 1.25 1.25V6.4a1.25 1.25 0 1 1-2.5 0v-.11l-5.72 5.72a1.25 1.25 0 0 1-1.76 0l-1.77-1.76-4.12 4.13a1.25 1.25 0 1 1-1.77-1.77l5-5a1.25 1.25 0 0 1 1.77 0l1.76 1.77 4.83-4.83h-.1a1.25 1.25 0 1 1 0-2.5Z"
	})]
});
export default SvgAnalyticsBarsAscend;
